import { useState } from 'react';
import { useSelector } from 'react-redux';
import { EmailRegEx } from 'data/globalConstants';
import { common, profile, validation } from 'lang/en.json';
import { authSelector } from 'store/auth';
import styles from 'styles/modules/SidescreenAddExpert.module.scss';
import Input from 'components/Input';
import Uploader from 'components/Uploader';
import AddContent from 'components/Profile/AddContent';
import EditContent from 'components/Profile/EditContent';
import Typo from 'components/Typo';

const Details = ({
    callback,
    register,
    errors,
    picturePreview,
    data,
    handleFile,
    isEditable,
}) => {
    const { isAuthorized } = useSelector(authSelector);
    const [formData, setFormData] = useState(data ?? null);
    const [uploadPopupActive, setUploadPopupActive] = useState(false);

    const handleKeyUp = (name, val) => {
        let newFormData = JSON.parse(JSON.stringify(formData));
        newFormData[name] = val;
        setFormData(newFormData);
        callback(newFormData);
    };

    const inputs = [
        {
            label: common.name,
            name: 'name',
            color: 'dark',
            error: errors['name'],
            register: register({
                required: validation.required,
            }),
            onKeyUp: handleKeyUp,
            value: formData?.name ? formData?.name : '',
        },
        {
            label: profile.header.experts.sidebar.position,
            name: 'position',
            color: 'dark',
            error: errors['position'],
            register,
            onKeyUp: handleKeyUp,
            value: formData?.position ? formData?.position : '',
        },
        {
            label: common.email,
            name: 'email',
            color: 'dark',
            error: errors['email'],
            register: register({
                pattern: {
                    value: EmailRegEx,
                    message: validation.email,
                },
            }),
            onKeyUp: handleKeyUp,
            value: formData?.email ? formData?.email : '',
        },
        {
            label: common.phone,
            name: 'phone',
            color: 'dark',
            error: errors['phone'],
            register,
            onKeyUp: handleKeyUp,
            value: formData?.phone ? formData?.phone : '',
        },
    ];

    const handleClick = () => {
        setUploadPopupActive(true);
    };

    const handlePopupCancel = () => {
        setUploadPopupActive(false);
    };

    let button = null;

    if (picturePreview || formData.image?.path) {
        button = (
            <div
                className={[
                    styles.logoWrapper,
                    !isAuthorized && isEditable ? styles.logoWrapperPublic : '',
                ].join(' ')}
            >
                <img
                    className={styles.companyLogo}
                    src={
                        formData?.image?.path !== '' && picturePreview
                            ? picturePreview
                            : formData?.image?.path
                    }
                />
                <div className={styles.logoEdit}>
                    <EditContent
                        data={{
                            onClick: handleClick,
                        }}
                    />
                </div>
            </div>
        );
    } else {
        button = (
            <div className={styles.bioLogoArea} onClick={handleClick}>
                <AddContent data={{ label: null }} />
            </div>
        );
    }

    return (
        <section className={styles.bio}>
            <Uploader
                isActive={uploadPopupActive}
                croppable={true}
                returnFile={true}
                onCancel={handlePopupCancel}
                onSubmit={(file) => {
                    handleFile(file);
                    setUploadPopupActive(false);
                }}
                allowedTypes={'images'}
            />

            <div className={styles.bioLogo}>
                {isAuthorized && (
                    <Typo variant={'body'} className={'mb-xxs'}>
                        {profile.header.experts.sidebar.picture}
                    </Typo>
                )}

                {button}
            </div>

            <div className={styles.bioBody}>
                {inputs.map((item, key) => {
                    return <Input {...item} key={`input-${key}`} />;
                })}
            </div>
        </section>
    );
};

export default Details;
